import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import {
  translateUserRole,
  translateUserStatus,
  translateUserLanguage,
  translateUserBoolean
} from "./utils";
const Users = ({
  users,
  handleDeleteUser,
  handleEditUser,
  handleChangeFile
}) => {
  const _handleChangeFile = (e, user) => {
    if (handleChangeFile && typeof handleChangeFile === "function") {
      handleChangeFile(e, user,'user');
    }
  };

  const handleEdit = (user, e) => {
    e.stopPropagation();
    if (handleEditUser && typeof handleEditUser === "function") {
      handleEditUser(user);
    }
  };
  const handleDelete = (user, e) => {
    e.stopPropagation();
    if (handleDeleteUser && typeof handleDeleteUser === "function") {
      handleDeleteUser(user);
    }
  };
  const renderList = () => {
    if (!users || users.length <= 0) {
      return null;
    }
    return users.map((user, key) => {
      const username = user.organizationTenant?user.organizationTenant.name:''
      console.log(user)
      return (
        <div key={key} className="user-item_container">
          <div className="user-item" key={key}>
            {user.file ? (
              <img
                src={`https://sopia.ams3.digitaloceanspaces.com/production/${user.file.key}`}
                alt="avatar"
                className="avatar"
              />
            ) : (
              <i className="material-icons default-avatar">account_circle</i>
            )}
            <div className="text">
              {username}
            </div>
            <div className="text">{user.email}</div>
            <div className="tool blue-tool" onClick={e => handleEdit(user, e)}>
              Edit
            </div>
            <div className="tool red-tool" onClick={e => handleDelete(user, e)}>
              Delete
            </div>
            <input type="file" onChange={e => _handleChangeFile(e, user)} />
          </div>
        </div>
      );
    });
  };

  return <div className="admin-users">{renderList()}</div>;
};

export default withRouter(connect()(Users));
